module.exports = __webpack_public_path__ + "static/media/05.cf849ec1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/05.jpg
// module id = 567
// module chunks = 0